import { useEffect, useState } from "react";
import api from "@/lib/api";
import { dateTime } from "@/lib/format";
import { Scroll } from "@phosphor-icons/react";

export default function Audit() {
  const [entries, setEntries] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setEntries(r.data)); }, []);

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-heading text-3xl font-black tracking-tight">Audit Trail</h1>
        <p className="mt-1 text-sm text-muted-foreground">Immutable record of every money-affecting action. This is money — it must reconcile.</p>
      </div>

      <div className="overflow-hidden rounded-sm border border-border">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-card"><tr className="border-b border-border">
            {["Timestamp", "Entity", "Action", "Actor"].map((c) => <th key={c} className="px-4 py-3 overline text-left">{c}</th>)}
          </tr></thead>
          <tbody>
            {entries.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-16 text-center">
                <Scroll size={32} className="mx-auto mb-3 text-muted-foreground" />
                <div className="text-sm text-muted-foreground">No audit entries yet.</div>
              </td></tr>
            )}
            {entries.map((e) => (
              <tr key={e.id} data-testid={`audit-row-${e.id}`} className="border-b border-border hover:bg-accent transition-colors duration-200">
                <td className="px-4 py-2.5 font-mono text-muted-foreground">{dateTime(e.timestamp)}</td>
                <td className="px-4 py-2.5"><span className="font-mono text-xs uppercase tracking-wide">{e.entity}</span></td>
                <td className="px-4 py-2.5 font-medium">{e.action}</td>
                <td className="px-4 py-2.5 font-mono text-xs text-muted-foreground">{e.actor}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
